import { SelectProps } from 'antd/lib/select';
import { Select } from 'antd';
import { useMemo } from 'react';
import { HorseSlotsEnum, Option } from '../../../types';

function SelectHorseSlots({
  value,
  ...props
}: SelectProps<HorseSlotsEnum, Option>) {
  const options = useMemo(
    () => Object.entries(HorseSlotsEnum).map(([_, text]) => ({
      label: text,
      value: text,
    })),
    [],
  );

  return (
    <Select
      {...props}
      options={options}
      allowClear
      placeholder="Please select"
      value={value || undefined}
    />
  );
}

export default SelectHorseSlots;
